/**
 * Label + control + one message slot. The error replaces the hint rather than
 * stacking with it, so the row never changes height when a message appears, and
 * carries the id that the control's aria-describedby points at.
 */
export default function Field({ label, hint, error, children, id, required }) {
  return (
    <div className="field">
      {label && (
        <label htmlFor={id}>
          {label}
          {required && (
            <span className="req" aria-hidden="true">
              {' '}
              *
            </span>
          )}
        </label>
      )}
      {children}
      {error ? (
        <p className="field-error" id={id ? `${id}-error` : undefined} role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className="hint">{hint}</p>
      ) : null}
    </div>
  );
}
